import ChartBase from "@/components/Elements/Charts/ChartBase";

import { useHistogramChartOptions } from "./useHistogramChartOptions";

const HistogramChart = ({
  data = [],
  categoriesTitle,
  valuesTitle,
  formatCategoryLabel = (category) => category,
  formatValueLabel = (value) => value,
  formatTooltipValue = (value) => value,
  controlled,
  onSelectedCategoryChange,
  ...chartBaseProps
}) => {
  const options = useHistogramChartOptions({
    data,
    categoriesTitle,
    valuesTitle,
    formatCategoryLabel,
    formatValueLabel,
    formatTooltipValue,
    controlled,
  });

  const onSelectChange = ({ selected }) => {
    // We are in selectedMode = 'single', so let's just pick the first selected value
    onSelectedCategoryChange?.(selected[0]);
  };

  return (
    <ChartBase
      {...chartBaseProps}
      options={options}
      onSelectChange={onSelectChange}
    />
  );
};

export default HistogramChart;
